// general modal with options for rotation on zoomed images
Fancybox.bind('.js-modal', {
    backFocus: false,
    clickContent: false,
    wheel: false,
    Toolbar: false,
    Image: {
        Panzoom: {
            maxScale: function () {
                return 0;
            },
        },
    },
    'overlayOpacity': 0,

    on: {
        closing: (fancybox, slide) => {
            $('body').addClass('modal-closing');
            $('.js-modal').removeClass('is-open');
        },
        reveal: (fancybox, slide) => {
            $('body').removeClass('modal-closing');
        },
        destroy: (fancybox, slide) => {
            $('body').removeClass('modal-rotate-left modal-rotate-right');
        },
    },
});


Fancybox.bind('.wp-block-image img', {
    backFocus: false,
    clickContent: false,
    wheel: false,
    Toolbar: false,
});


// adds rotate class to body when modal opens
$('.js-modal').each(function () {
    $(this).on('click', function () {
        $(this).addClass('is-open')
        var modalRotate = $(this).attr('data-rotate');
        $('body').addClass('modal-rotate-' + modalRotate);
    });
});

// steal this deck modal
Fancybox.bind('.js-modal-deck', {
    backFocus: false,
    wheel: false,
    src: '#modalDeck',
    Toolbar: false,
});

// fullscreen events modal
$('.js-modal-events, a[href="#js-modal-events"]').on('click', function (e) {
    e.preventDefault();
    $('body').addClass('no-scroll');
    $('#modalEvents')
        .addClass('modal-open')
        .attr('aria-modal', 'true')
        .removeAttr('aria-hidden');

    setTimeout(function () {
        $('#modalEvents #input_2_1').focus()
    }, 300);
});

// close events modal
$('.js-modal-close').on('click', function () {
    $('body').removeClass('no-scroll');
    $('#modalEvents')
        .removeClass('modal-open')
        .attr('aria-hidden', 'true')
        .removeAttr('aria-modal');
});

// application referral link copy
$('.js-referral-link').on('click', function () {
    $('.js-referral-text').addClass('is-visible')
});
